import { useContext } from 'react';
import { DataType } from '../ModalViewReceipt';
import { ContextApp } from '../../../../../contexts/ContextApp';
import { IViewModalReceiptState } from '../../../Receipt';
import MomentTimezoneService from '../../../../../services/moment-timezone/MomentTimezoneService';
import moment from 'moment';
import { formatValue } from '../../../../../shared/formatValue';

const useGetGeneralTabContent = (state: IViewModalReceiptState) => {
  const { t } = useContext(ContextApp);
  const { getDate } = MomentTimezoneService();

  const isServiceLiquidationInvoice =
    state.data?.receipt_type?.translation_key ===
    'receipt_type.serviceLiquidationInvoice';

  const generalTabContent1: DataType[] = [
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.receiptNumber'),
      value: state.data?.receipt_number,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.type'),
      value: state.data?.receipt_type?.name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.letter'),
      value: state.data?.receipt_letter?.name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.receiptDate'),
      value: getDate({ element: moment(state.data?.receipt_date).toDate() }),
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.dueDate'),
      value: getDate({ element: moment(state.data?.due_date).toDate() }),
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.purchaseOrder'),
      value: state.data?.purchase_order,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.relatedDocumentName'),
      value: state.data?.related_document_name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.relatedDocumentNumber'),
      value: state.data?.related_document_number,
    },
    ...(isServiceLiquidationInvoice
      ? [
          {
            label: t('ReceiptTray.modalViewReceipt.generalTab.receiptPeriod'),
            value: state.data?.receipt_period ?? undefined,
          },
        ]
      : []),
  ];

  const generalTabContent2: DataType[] = [
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.senderName'),
      value: state.data?.sender?.name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.senderTaxType'),
      value: state.data?.sender?.tax_type?.name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.senderTaxNumber'),
      value: state.data?.sender?.tax_number?.toString(),
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.senderTaxCondition'),
      value: state.data?.sender?.tax_condition,
    },
  ];

  const generalTabContent3: DataType[] = [
    {
      label: t(
        'ReceiptTray.modalViewReceipt.generalTab.receiptVerificationCode',
      ),
      value: state.data?.receipt_verification_code,
    },
    {
      label: t(
        'ReceiptTray.modalViewReceipt.generalTab.receiptVerificationDueDate',
      ),
      value: getDate({
        element: moment(state.data?.receipt_verification_due_date).toDate(),
      }),
    },
  ];

  const generalTabContent4: DataType[] = [
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.currencyType'),
      value:
        state.data?.currency_type?.code.toString() +
        (state.data?.currency_type?.name
          ? ' (' + state.data?.currency_type?.name.toString() + ')'
          : ''),
    },
    {
      label: t(
        'ReceiptTray.modalViewReceipt.generalTab.exchangeRateQuoteValue',
      ),
      value: state.data?.exchange_rate_quote_value
        ? formatValue(state.data?.exchange_rate_quote_value)
        : undefined,
    },
    {
      label: t(
        'ReceiptTray.modalViewReceipt.generalTab.exchangeRateQuoteCurrency',
      ),
      value: state.data?.exchange_rate_quote_currency,
    },
    {
      label: t(
        'ReceiptTray.modalViewReceipt.generalTab.exchangeRateQuoteDescription',
      ),
      value: state.data?.exchange_rate_quote_description,
    },
  ];

  const generalTabContent5: DataType[] = [
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.customerName'),
      value: state.data?.customer?.name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.customerTaxType'),
      value: state.data?.customer?.tax_type?.name,
    },
    {
      label: t('ReceiptTray.modalViewReceipt.generalTab.customerTaxNumber'),
      value: state.data?.customer?.tax_number?.toString(),
    },
    ...(isServiceLiquidationInvoice
      ? [
          {
            label: t(
              'ReceiptTray.modalViewReceipt.generalTab.customerAccountNumber',
            ),
            value: state.data?.customer?.account_number ?? undefined,
          },
        ]
      : []),
  ];

  const generalTabContent6: DataType[] = isServiceLiquidationInvoice
    ? [
        {
          label: t('ReceiptTray.modalViewReceipt.generalTab.firstDueDate'),
          value: state.data?.first_due_date
            ? getDate({
                element: moment(state.data.first_due_date).toDate(),
              })
            : undefined,
        },
        {
          label: t('ReceiptTray.modalViewReceipt.generalTab.firstDueDateTotal'),
          value: state.data?.first_due_date_total
            ? formatValue(state.data.first_due_date_total)
            : undefined,
        },
        {
          label: t('ReceiptTray.modalViewReceipt.generalTab.secondDueDate'),
          value: state.data?.second_due_date
            ? getDate({
                element: moment(state.data.second_due_date).toDate(),
              })
            : undefined,
        },
        {
          label: t(
            'ReceiptTray.modalViewReceipt.generalTab.secondDueDateTotal',
          ),
          value: state.data?.second_due_date_total
            ? formatValue(state.data.second_due_date_total)
            : undefined,
        },
      ]
    : [];

  return {
    generalTabContent1,
    generalTabContent2,
    generalTabContent3,
    generalTabContent4,
    generalTabContent5,
    generalTabContent6,
  };
};
export default useGetGeneralTabContent;
